export default __webpack_public_path__ + "static/media/asio_logo.d826b388.jpg";